import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { siteConfig } from "../siteConfig";
import Reveal from "../components/Reveal";

const { blog, colors, hero } = siteConfig;

const BlogCard = ({ title, excerpt, slug }) => (
  <Link
    to={`/blog/${slug}`}
    className="flex flex-col rounded-2xl p-8 transition-opacity hover:opacity-90"
    style={{ backgroundColor: colors.dark }}
  >
    <h3
      className="font-display font-black text-white uppercase leading-tight mb-4"
      style={{ fontSize: "clamp(1rem,1.5vw,1.15rem)", letterSpacing: "0.01em" }}
    >
      {title}
    </h3>
    <p className="text-white/55 text-sm leading-relaxed flex-1 mb-6">{excerpt}</p>
    <span
      className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-widest"
      style={{ color: colors.primary }}
    >
      Read Full Post <ArrowRight className="w-3.5 h-3.5" />
    </span>
  </Link>
);

const BlogPage = () => (
  <>
    {/* Hero banner */}
    <section
      className="relative flex items-end"
      style={{
        minHeight: "38vh",
        backgroundImage: `url(${hero.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 100%)" }} />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 pb-12 pt-32">
        <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: colors.primary }}>
          Resources &amp; Tips
        </p>
        <h1 className="font-display font-black text-white leading-tight" style={{ fontSize: "clamp(2.2rem,5vw,3.75rem)" }}>
          Our Blog
        </h1>
      </div>
    </section>

    {/* Posts grid */}
    <section className="py-20" style={{ backgroundColor: colors.light }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">

        {/* Section header */}
        <Reveal as="div" className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12" style={{ backgroundColor: colors.primary }} />
            <span className="text-xs font-black uppercase tracking-widest" style={{ color: colors.primary }}>
              {blog.eyebrow}
            </span>
            <div className="h-px w-12" style={{ backgroundColor: colors.primary }} />
          </div>
          <h2
            className="font-display font-black uppercase leading-none mb-5"
            style={{ fontSize: "clamp(2.5rem,7vw,5rem)", color: colors.dark }}
          >
            {blog.heading}
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-sm leading-relaxed">{blog.sub}</p>
        </Reveal>

        {/* Cards */}
        {blog.posts.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {blog.posts.map((post, i) => (
              <Reveal key={post.title} delay={(i % 3) * 90}>
                <BlogCard {...post} />
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal as="div" className="flex flex-col items-center justify-center py-24 text-center">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
              style={{ backgroundColor: `${colors.primary}18` }}
            >
              <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: colors.primary }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10l6 6v10a2 2 0 01-2 2z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 4v6h6M9 12h6M9 16h4" />
              </svg>
            </div>
            <h2 className="font-display font-black text-2xl mb-3" style={{ color: colors.dark }}>
              Posts Coming Soon
            </h2>
            <p className="text-gray-500 max-w-md text-sm leading-relaxed">
              We're working on helpful guides, project spotlights, and industry tips.
              Check back soon — great content is on the way.
            </p>
          </Reveal>
        )}

      </div>
    </section>
  </>
);

export default BlogPage;
